import { logout } from '@shared/api';

/** 로그아웃 — 서버에 알리고 세션을 비운 뒤 처음 주소로(하드 네비게이션). */
export function useAppLogout(): () => void {
  return () => {
    void logout();
  };
}
